import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Alert } from '../components/Alert';
import { Field } from '../components/Field';
import { api } from '../lib/api';

/**
 * « Confirmez votre adresse » (27/09/2026).
 *
 * Un compte dont l'adresse n'a jamais été confirmée ne s'ouvre pas : la
 * connexion renvoie ici, et cet écran ne propose qu'UNE chose — recevoir un
 * nouveau lien. Tant que le lien n'est pas cliqué, rien du compte n'est
 * accessible.
 *
 * La réponse est la même que l'adresse ait un compte en attente ou non (le
 * serveur ne dit rien de plus) : le message reste donc conditionnel.
 */
export function ConfirmerAdressePage() {
  const [searchParams] = useSearchParams();
  const emailInitial = searchParams.get('email') ?? '';
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function renvoyer(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const email = String(new FormData(event.currentTarget).get('email') ?? '').trim();
    if (!email) return;
    setPending(true);
    setErreur(null);
    try {
      await api.post('/auth/verification/renvoyer', { email });
      setEnvoye(true);
    } catch {
      setErreur('Envoi impossible pour le moment. Réessayez dans quelques minutes.');
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthCard
      title="Confirmez votre adresse"
      subtitle="Votre compte n'est pas encore ouvert : cliquez le lien reçu par e-mail pour l'activer."
    >
      <Alert message={erreur} />
      {envoye ? (
        <Alert
          variant="success"
          message="Si un compte attend une confirmation pour cette adresse, un nouveau lien vient de lui être envoyé. Pensez à regarder dans les indésirables."
        />
      ) : (
        <form onSubmit={renvoyer}>
          <Field
            label="Adresse e-mail"
            name="email"
            type="email"
            autoComplete="email"
            required
            defaultValue={emailInitial}
          />
          <button className="btn" type="submit" disabled={pending}>
            {pending ? 'Envoi…' : 'Recevoir un nouveau lien'}
          </button>
        </form>
      )}
      <div className="links">
        <Link to="/login">Retour à la connexion</Link>
      </div>
    </AuthCard>
  );
}
